const CACHE_PREFIX = "docxAppendixCharts";
const MODULE_ORDER = ["Energiebilanz", "Benchmarking", "VALERI"];

function cacheKey(projectId) {
  return `${CACHE_PREFIX}:${projectId}`;
}

function readRaw(projectId) {
  if (!projectId) {
    return { chartsByModule: {}, updatedAt: null };
  }

  try {
    const raw = localStorage.getItem(cacheKey(projectId));
    if (!raw) {
      return { chartsByModule: {}, updatedAt: null };
    }
    const parsed = JSON.parse(raw);
    return {
      chartsByModule: parsed?.chartsByModule || {},
      updatedAt: parsed?.updatedAt || null,
    };
  } catch {
    return { chartsByModule: {}, updatedAt: null };
  }
}

function writeRaw(projectId, payload) {
  if (!projectId) {
    return;
  }
  localStorage.setItem(cacheKey(projectId), JSON.stringify(payload));
}

function normalizeCharts(charts, moduleName) {
  return (charts || []).map((entry) => ({
    id: entry?.id,
    title: entry?.title || entry?.id || "Diagramm",
    module: entry?.module || moduleName,
    imageBase64: entry?.imageBase64 || null,
  }));
}

export function storeDocxModuleCharts(projectId, moduleName, charts) {
  const current = readRaw(projectId);
  current.chartsByModule[moduleName] = normalizeCharts(charts, moduleName);
  current.updatedAt = new Date().toISOString();
  writeRaw(projectId, current);
}

export function getDocxCombinedCharts(projectId) {
  const { chartsByModule } = readRaw(projectId);
  const modules = Object.keys(chartsByModule)
    .sort((a, b) => {
      const ai = MODULE_ORDER.indexOf(a);
      const bi = MODULE_ORDER.indexOf(b);
      if (ai === -1 && bi === -1) {
        return a.localeCompare(b);
      }
      if (ai === -1) {
        return 1;
      }
      if (bi === -1) {
        return -1;
      }
      return ai - bi;
    });

  return modules.flatMap((moduleName) => chartsByModule[moduleName] || []);
}

export function getDocxCachedModules(projectId) {
  const { chartsByModule, updatedAt } = readRaw(projectId);
  return {
    modules: Object.keys(chartsByModule).filter((key) => (chartsByModule[key] || []).length > 0),
    updatedAt,
  };
}
